// @flow
import { get } from 'lodash';
import { reject } from 'redux-optimist-promise';

import { FETCH_ADDITIONAL_ACCOMMODATIONS } from 'Store/booking/additional-accommodations/additionalAccommodations.action';

type State = ?HTTPError;

const initialState: State = null;

function additionalAccommodationsErrorReducer(
  state: State = initialState,
  action: ?Action<*>,
): State {
  switch (get(action, 'type')) {
    case FETCH_ADDITIONAL_ACCOMMODATIONS:
      return initialState;

    case reject(FETCH_ADDITIONAL_ACCOMMODATIONS):
      const error = get(action, 'payload.errors[0]', {});
      return {
        statusCode: error.statusCode || 500,
        message: error.message || 'UNKNOWN ERROR',
      };

    default:
      return state;
  }
}

export default additionalAccommodationsErrorReducer;
